import { WMBaseItem } from "./baseitem";
import { toRaw } from "vue";

const rec_index_cache = new WeakMap();

function recording_index(list) {
  let index = rec_index_cache.get(toRaw(list));
  if (index == null) {
    index = { map: new Map(), len: 0 };
    rec_index_cache.set(toRaw(list), index);
  }
  if (index.len > list.length) {
    index.map.clear();
    index.len = 0;
  }
  for (let i = index.len; i < list.length; i++) {
    const item = list[i];
    if (item != null) index.map.set(item.id, item);
  }
  index.len = list.length;
  return index.map;
}

export default class RecordingInfo extends WMBaseItem {
  get zoneId() {
    return this.dto.zoneId;
  }

  get start() {
    return this.dto.start;
  }

  get stop() {
    return this.dto.stop;
  }

  constructor(dto, identification) {
    super(dto);
    this.app_prop.project_id = identification.project_id;
    this.app_prop.zone_id = identification.zone_id;
  }

  props_template() {
    return {
      project_id: 0,
      zone_id: 0
    };
  }

  upload_changes() {
    return this.Network.recording_info.update(
      this.app_prop.project_id,
      this.app_prop.zone_id,
      this.id,
      this.changes()
    );
  }

  static new_item_instance(dto, identification) {
    return new RecordingInfo(dto, identification);
  }

  static find_parent(app, identification) {
    return app.$appm.get_zone(identification.project_id, identification.zone_id)
      .recording_infos;
  }

  static find(app, id, identification) {
    const zone = app.$appm.get_zone(
      identification.project_id,
      identification.zone_id
    );
    if (zone == null) return null;
    return recording_index(zone.recording_infos).get(id) ?? null;
  }
}
